import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getSuperWallets } from "../../../redux/actions/profile";

const PRIMARY = "#a7cc48";
const BG = "#2c2d3f";

export default function Wallets() {
  const dispatch = useDispatch();
  const history = useHistory();
  const wallets = useSelector((s) => s.profile.superWallets || []);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("all");

  useEffect(() => { dispatch(getSuperWallets()); }, [dispatch]);

  const filtered = wallets.filter((w) => {
    const q = search.toLowerCase();
    const email = w.userId?.email || "";
    const store = w.userId?.storeInfo?.storeName || "";
    const account = w.accountNumber || "";
    const matchSearch = !q || email.toLowerCase().includes(q) || store.toLowerCase().includes(q) || account.includes(q);
    const matchFilter = filter === "all" ? true : filter === "active" ? w.active : !w.active;
    return matchSearch && matchFilter;
  });

  const totalBalance = wallets.reduce((sum, w) => sum + (w.balance || 0), 0);
  const activeCount = wallets.filter((w) => w.active).length;
  const bvnCount = wallets.filter((w) => w.bvnVerified).length;

  const counts = { all: wallets.length, active: activeCount, inactive: wallets.length - activeCount };

  return (
    <div style={S.root}>
      <div style={S.header}>
        <div>
          <h2 style={S.title}>Wallets</h2>
          <p style={S.sub}>All merchant Paystack wallets across the platform</p>
        </div>
        <span style={S.badge}>{wallets.length} wallets</span>
      </div>

      <div style={S.statsRow}>
        <div style={{ ...S.statCard, borderTop: "3px solid " + PRIMARY }}>
          <i className="bi bi-cash-stack" style={{ fontSize: 22, color: PRIMARY }} />
          <div style={{ marginLeft: 14 }}>
            <div style={S.statNum}>₦{totalBalance.toLocaleString("en-NG", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
            <div style={S.statLabel}>Total Wallet Balance</div>
          </div>
        </div>
        <div style={{ ...S.statCard, borderTop: "3px solid #4fb0c6" }}>
          <i className="bi bi-check-circle-fill" style={{ fontSize: 22, color: "#4fb0c6" }} />
          <div style={{ marginLeft: 14 }}>
            <div style={{ ...S.statNum, color: "#4fb0c6" }}>{activeCount}</div>
            <div style={S.statLabel}>Active Wallets</div>
          </div>
        </div>
        <div style={{ ...S.statCard, borderTop: "3px solid #f4a261" }}>
          <i className="bi bi-shield-check" style={{ fontSize: 22, color: "#f4a261" }} />
          <div style={{ marginLeft: 14 }}>
            <div style={{ ...S.statNum, color: "#f4a261" }}>{bvnCount}</div>
            <div style={S.statLabel}>BVN Verified</div>
          </div>
        </div>
        <div style={{ ...S.statCard, borderTop: "3px solid #9b5de5" }}>
          <i className="bi bi-bank" style={{ fontSize: 22, color: "#9b5de5" }} />
          <div style={{ marginLeft: 14 }}>
            <div style={{ ...S.statNum, color: "#9b5de5" }}>{wallets.length}</div>
            <div style={S.statLabel}>Total Wallets</div>
          </div>
        </div>
      </div>

      <div style={S.toolbar}>
        <div style={S.searchWrap}>
          <i className="bi bi-search" style={S.searchIcon} />
          <input
            style={S.search}
            placeholder="Search by email, store, or account number…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div style={S.tabs}>
          {["all", "active", "inactive"].map((t) => (
            <button key={t} style={{ ...S.tab, ...(filter === t ? S.tabActive : {}) }} onClick={() => setFilter(t)}>
              {t.charAt(0).toUpperCase() + t.slice(1)} ({counts[t]})
            </button>
          ))}
        </div>
      </div>

      <div style={S.tableWrap}>
        <table style={S.table}>
          <thead>
            <tr>
              {["Merchant", "Account Number", "Bank", "Balance", "BVN", "Status", "Txns", "Created", ""].map((h) => (
                <th key={h} style={S.th}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr><td colSpan={8} style={{ ...S.td, textAlign: "center", color: "#bbb", padding: 32 }}>No wallets found</td></tr>
            ) : filtered.map((w) => (
              <tr key={w._id} style={S.tr}>
                <td style={S.td}>
                  <div style={{ fontWeight: 600, color: BG, fontSize: 13 }}>{w.userId?.storeInfo?.storeName || "—"}</div>
                  <div style={{ fontSize: 11, color: "#999" }}>{w.userId?.email || "—"}</div>
                </td>
                <td style={{ ...S.td, fontFamily: "monospace", fontSize: 13, fontWeight: 600 }}>{w.accountNumber || "—"}</td>
                <td style={{ ...S.td, fontSize: 12, color: "#555" }}>{w.bankName || "—"}</td>
                <td style={{ ...S.td, fontWeight: 700, color: BG }}>
                  ₦{(w.balance || 0).toLocaleString("en-NG", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </td>
                <td style={S.td}>
                  {w.bvnVerified ? (
                    <span style={S.verifiedTag}><i className="bi bi-shield-check" /> Verified</span>
                  ) : (
                    <span style={S.unverifiedTag}><i className="bi bi-shield-x" /> Pending</span>
                  )}
                </td>
                <td style={S.td}>
                  <span style={{ ...S.statusPill, background: w.active ? "rgba(167,204,72,0.12)" : "#f5f5f5", color: w.active ? "#5a8a00" : "#aaa" }}>
                    {w.active ? "Active" : "Inactive"}
                  </span>
                </td>
                <td style={{ ...S.td, textAlign: "center" }}>{w.txCount || 0}</td>
                <td style={{ ...S.td, fontSize: 12, color: "#888" }}>
                  {w.createdAt ? new Date(w.createdAt).toLocaleDateString() : "—"}
                </td>
                <td style={S.td}>
                  {w.userId?._id && (
                    <button
                      style={S.viewBtn}
                      onClick={() => history.push(`/admin/wallets/${w.userId._id}`)}
                    >
                      <i className="bi bi-eye" style={{ marginRight: 4 }} />View
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const S = {
  root: { paddingBottom: 40 },
  header: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 12, marginBottom: 24 },
  title: { fontSize: 22, fontWeight: 800, color: BG, margin: 0 },
  sub: { fontSize: 13, color: "#888", marginTop: 4 },
  badge: { background: "rgba(167,204,72,0.12)", color: "#5a8a00", border: "1px solid " + PRIMARY, borderRadius: 20, padding: "5px 14px", fontSize: 12, fontWeight: 700 },
  statsRow: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 16, marginBottom: 24 },
  statCard: { background: "#fff", borderRadius: 10, padding: "16px 18px", boxShadow: "0 2px 10px rgba(0,0,0,0.06)", display: "flex", alignItems: "center" },
  statNum: { fontSize: 20, fontWeight: 800, color: PRIMARY, lineHeight: 1.2 },
  statLabel: { fontSize: 12, color: "#888", marginTop: 2 },
  toolbar: { display: "flex", gap: 12, alignItems: "center", marginBottom: 18, flexWrap: "wrap" },
  searchWrap: { position: "relative", flex: 1, minWidth: 220 },
  searchIcon: { position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "#bbb", fontSize: 14 },
  search: { width: "100%", padding: "9px 12px 9px 36px", borderRadius: 8, border: "1.5px solid #eee", fontSize: 13, outline: "none", boxSizing: "border-box" },
  tabs: { display: "flex", gap: 6 },
  tab: { padding: "7px 14px", borderRadius: 20, border: "1.5px solid #e0e0e0", background: "#fff", fontSize: 12, fontWeight: 600, cursor: "pointer", color: "#888" },
  tabActive: { background: PRIMARY, borderColor: PRIMARY, color: "#fff" },
  tableWrap: { background: "#fff", borderRadius: 10, overflowX: "auto", boxShadow: "0 2px 10px rgba(0,0,0,0.06)", WebkitOverflowScrolling: "touch" },
  table: { width: "100%", borderCollapse: "collapse", minWidth: 650 },
  th: { background: BG, color: "#fff", padding: "11px 14px", textAlign: "left", fontSize: 12, fontWeight: 600 },
  tr: { borderBottom: "1px solid #f5f5f5" },
  td: { padding: "11px 14px", fontSize: 13, color: "#555", verticalAlign: "middle" },
  verifiedTag: { background: "rgba(167,204,72,0.12)", color: "#5a8a00", borderRadius: 20, padding: "2px 10px", fontSize: 11, fontWeight: 700 },
  unverifiedTag: { background: "#f5f5f5", color: "#aaa", borderRadius: 20, padding: "2px 10px", fontSize: 11, fontWeight: 700 },
  statusPill: { borderRadius: 20, padding: "2px 10px", fontSize: 11, fontWeight: 700 },
  viewBtn: { background: "rgba(167,204,72,0.12)", border: "1px solid " + PRIMARY, borderRadius: 6, color: "#5a8a00", padding: "4px 12px", cursor: "pointer", fontSize: 12, fontWeight: 600, display: "inline-flex", alignItems: "center" },
};
